export function getInstitutionPathPrefix(type: string, id: number) {
  return `/i/${type.toLowerCase()}/${id}`;
}
